import { Action, createReducer, on } from '@ngrx/store';
import { IBulkImportTemplateTypes } from '../models/bulk-import-template-types.model';
import * as actions from '../actions';

export const bulkImportTemplateTypesFeatureKey = 'bulkImportTemplateTypes';

export interface BulkImportTemplateTypeState {
  loadBulkImportTemplateTypeResponse: IBulkImportTemplateTypes[];
}

export const initialState: BulkImportTemplateTypeState = {
  loadBulkImportTemplateTypeResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBulkImportTemplateTypesSuccess, (state, action) => ({
    ...state,
    loadBulkImportTemplateTypeResponse: action.response
  }))
);

export const getBulkImportTemplateTypeResponse = (state: BulkImportTemplateTypeState) => state.loadBulkImportTemplateTypeResponse;
